import {detectMob} from "./mobileHelper";

interface TooltipProps {
    title?: string;
    subtitle?: string;
    leftTailOffset?: number;
    hideImmediately?: boolean;
    isCentered?: boolean;
}

const tooltipHtml = `
<div class="tooltip">
    <div class="tooltip-tail"></div>
    <div class="tooltip-content">
        <div class="tooltip-content__title">
        </div>
        <div class="tooltip-content__subtitle">
        </div>
    </div>
</div>
`

class Tooltip {
    el: HTMLElement;
    title: string;
    subtitle?: string;
    hideImmediately?: boolean;
    tooltip: HTMLElement;
    tail: HTMLElement;
    leftTailOffset: number;
    bindedScrollEvent: any;
    tooltipClassName = 'tooltip';
    tooltipSelector = `.${this.tooltipClassName}`;

    constructor(el: HTMLElement, props: TooltipProps) {
        if (!props.title && !props.subtitle) {
            return;
        }

        this.el = el;

        const div = document.createElement('div');
        div.innerHTML = tooltipHtml;
        this.tooltip = div.querySelector(this.tooltipSelector) as HTMLElement;

        this.setProps(props);

        this.tail = this.tooltip.querySelector(this.tooltipSelector + '-tail') as HTMLElement;
        this.leftTailOffset = props.leftTailOffset || 0;
        this.bindedScrollEvent = this.scrollEvent.bind(this);

        this.attachListeners();
    }

    setProps(props: TooltipProps) {
        if (!props.title && !props.subtitle) {
            return;
        }

        props.title && (this.title = props.title);
        props.subtitle && (this.subtitle = props.subtitle);
        this.hideImmediately = props.hideImmediately || false;

        const tooltipTitle = this.tooltip.querySelector('.tooltip-content__title') as HTMLElement,
        tooltipSubtitle = this.tooltip.querySelector('.tooltip-content__subtitle') as HTMLElement;

        tooltipTitle && this.title && (tooltipTitle.innerHTML = this.title);
        tooltipSubtitle && this.subtitle && (tooltipSubtitle.innerHTML = this.subtitle);

        if (props.isCentered) {
            this.tooltip.classList.add('is-centered');
        }
    }

    scrollEvent() {
        this.onMouseLeave()
    }

    attachListeners() {
        let timerId = 0;
        this.el.addEventListener('mouseenter', () => {
            clearTimeout(timerId);
            timerId = window.setTimeout(() => {
                document.body.append(this.tooltip);
                document.addEventListener('scroll', this.bindedScrollEvent, true);

                this.tooltip.style.opacity = '0';
                this.tooltip.style.display = 'block';
                const offsets = this.getOffsetRect(this.el);

                const toBottomEdge = document.documentElement.clientHeight - offsets.top;
                const tooltipHeight = this.tooltip.clientHeight;
                const remainsSpaceFromBottom = (toBottomEdge - tooltipHeight - 25) > 0;

                let top = 0;

                //остается ли место под тултипом
                if (remainsSpaceFromBottom) {
                    top = offsets.top + this.el.clientHeight + 12;
                    this.tooltip.classList.remove(this.tooltipClassName + '_from-top');
                }
                else {
                    //места не достаточно - показываем тултип сверху
                    top = offsets.top - this.el.clientHeight + 6 - tooltipHeight;
                    this.tooltip.classList.add(this.tooltipClassName + '_from-top');
                }

                let left = offsets.left - Math.round((this.tooltip.clientWidth / 2)) + Math.round((this.el.clientWidth / 2));

                if (left < 0) {
                    left = 8;
                }

                const offsetWithWidth = left + this.tooltip.clientWidth;

                if (offsetWithWidth >= window.innerWidth) {
                    const diff = offsetWithWidth - window.innerWidth;
                    left = left - diff - 16;
                }

                const middle = offsets.left + Math.round(this.el.clientWidth/2),
                    pos = middle - left - 1 + (this.leftTailOffset);
                this.tail.style.left = `${pos}px`;

                this.tooltip.style.top = top + 'px';
                this.tooltip.style.left = left + 'px';
                this.tooltip.style.opacity = '1';

                if (detectMob()) {
                    if (this.hideImmediately) {
                        clearTimeout(timerId);
                        this.onMouseLeave();
                    }
                    else {
                        setTimeout(() => {
                            clearTimeout(timerId);
                            this.onMouseLeave();
                        }, 3000)
                    }
                }
            }, 350)
        })

        this.el.addEventListener('mouseleave', () => {
            clearTimeout(timerId);
            this.onMouseLeave();
        });
    }

    onMouseLeave() {
        this.tooltip.style.display = '';
        document.removeEventListener('scroll', this.bindedScrollEvent, true);
        this.tooltip.style.opacity = '0';
        setTimeout(() => {
            this.tooltip.remove();
        }, 350);
    }

    getOffsetRect(elem: HTMLElement) {
        const box = elem.getBoundingClientRect()

        const body = document.body
        const docElem = document.documentElement

        const scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop
        const scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft

        const clientTop = docElem.clientTop || body.clientTop || 0
        const clientLeft = docElem.clientLeft || body.clientLeft || 0

        const top  = box.top +  scrollTop - clientTop
        const left = box.left + scrollLeft - clientLeft

        return { top: Math.round(top), left: Math.round(left) }
    }
}

export { Tooltip, TooltipProps }